// AUTO-GENERATED FILE - DO NOT EDIT
import {
  ToothModelHollowHingedEmbossedNoneSVG,
  ToothModelHollowHingedEmbossedPalateSVG,
  ToothModelHollowHingedEngravedNoneSVG,
  ToothModelHollowHingedEngravedPalateSVG,
  ToothModelHollowHingedNoneNoneSVG,
  ToothModelHollowHingedNonePalateSVG,
  ToothModelHollowNoneEmbossedNoneSVG,
  ToothModelHollowNoneEmbossedPalateSVG,
  ToothModelHollowNoneEngravedNoneSVG,
  ToothModelHollowNoneEngravedPalateSVG,
  ToothModelHollowNoneNoneNoneSVG,
  ToothModelHollowNoneNonePalateSVG,
  ToothModelHollowPillarsEmbossedNoneSVG,
  ToothModelHollowPillarsEmbossedPalateSVG,
  ToothModelHollowPillarsEngravedNoneSVG,
  ToothModelHollowPillarsEngravedPalateSVG,
  ToothModelHollowPillarsNoneNoneSVG,
  ToothModelHollowPillarsNonePalateSVG,
  ToothModelSolidHingedEmbossedNoneSVG,
  ToothModelSolidHingedEmbossedPalateSVG,
  ToothModelSolidHingedEngravedNoneSVG,
  ToothModelSolidHingedEngravedPalateSVG,
  ToothModelSolidHingedNoneNoneSVG,
  ToothModelSolidHingedNonePalateSVG,
  ToothModelSolidNoneEmbossedNoneSVG,
  ToothModelSolidNoneEmbossedPalateSVG,
  ToothModelSolidNoneEngravedNoneSVG,
  ToothModelSolidNoneEngravedPalateSVG,
  ToothModelSolidNoneNoneNoneSVG,
  ToothModelSolidNoneNonePalateSVG,
  ToothModelSolidPillarsEmbossedNoneSVG,
  ToothModelSolidPillarsEmbossedPalateSVG,
  ToothModelSolidPillarsEngravedNoneSVG,
  ToothModelSolidPillarsEngravedPalateSVG,
  ToothModelSolidPillarsNoneNoneSVG,
  ToothModelSolidPillarsNonePalateSVG
} from "@/components/Icon/Teeth";

// Mapping from file name to component.
export const toothComponents: Record<string, React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>> = {
  "hollow-hinged-embossed-none.svg": ToothModelHollowHingedEmbossedNoneSVG,
  "hollow-hinged-embossed-palate.svg": ToothModelHollowHingedEmbossedPalateSVG,
  "hollow-hinged-engraved-none.svg": ToothModelHollowHingedEngravedNoneSVG,
  "hollow-hinged-engraved-palate.svg": ToothModelHollowHingedEngravedPalateSVG,
  "hollow-hinged-none-none.svg": ToothModelHollowHingedNoneNoneSVG,
  "hollow-hinged-none-palate.svg": ToothModelHollowHingedNonePalateSVG,
  "hollow-none-embossed-none.svg": ToothModelHollowNoneEmbossedNoneSVG,
  "hollow-none-embossed-palate.svg": ToothModelHollowNoneEmbossedPalateSVG,
  "hollow-none-engraved-none.svg": ToothModelHollowNoneEngravedNoneSVG,
  "hollow-none-engraved-palate.svg": ToothModelHollowNoneEngravedPalateSVG,
  "hollow-none-none-none.svg": ToothModelHollowNoneNoneNoneSVG,
  "hollow-none-none-palate.svg": ToothModelHollowNoneNonePalateSVG,
  "hollow-pillars-embossed-none.svg": ToothModelHollowPillarsEmbossedNoneSVG,
  "hollow-pillars-embossed-palate.svg": ToothModelHollowPillarsEmbossedPalateSVG,
  "hollow-pillars-engraved-none.svg": ToothModelHollowPillarsEngravedNoneSVG,
  "hollow-pillars-engraved-palate.svg": ToothModelHollowPillarsEngravedPalateSVG,
  "hollow-pillars-none-none.svg": ToothModelHollowPillarsNoneNoneSVG,
  "hollow-pillars-none-palate.svg": ToothModelHollowPillarsNonePalateSVG,
  "solid-hinged-embossed-none.svg": ToothModelSolidHingedEmbossedNoneSVG,
  "solid-hinged-embossed-palate.svg": ToothModelSolidHingedEmbossedPalateSVG,
  "solid-hinged-engraved-none.svg": ToothModelSolidHingedEngravedNoneSVG,
  "solid-hinged-engraved-palate.svg": ToothModelSolidHingedEngravedPalateSVG,
  "solid-hinged-none-none.svg": ToothModelSolidHingedNoneNoneSVG,
  "solid-hinged-none-palate.svg": ToothModelSolidHingedNonePalateSVG,
  "solid-none-embossed-none.svg": ToothModelSolidNoneEmbossedNoneSVG,
  "solid-none-embossed-palate.svg": ToothModelSolidNoneEmbossedPalateSVG,
  "solid-none-engraved-none.svg": ToothModelSolidNoneEngravedNoneSVG,
  "solid-none-engraved-palate.svg": ToothModelSolidNoneEngravedPalateSVG,
  "solid-none-none-none.svg": ToothModelSolidNoneNoneNoneSVG,
  "solid-none-none-palate.svg": ToothModelSolidNoneNonePalateSVG,
  "solid-pillars-embossed-none.svg": ToothModelSolidPillarsEmbossedNoneSVG,
  "solid-pillars-embossed-palate.svg": ToothModelSolidPillarsEmbossedPalateSVG,
  "solid-pillars-engraved-none.svg": ToothModelSolidPillarsEngravedNoneSVG,
  "solid-pillars-engraved-palate.svg": ToothModelSolidPillarsEngravedPalateSVG,
  "solid-pillars-none-none.svg": ToothModelSolidPillarsNoneNoneSVG,
  "solid-pillars-none-palate.svg": ToothModelSolidPillarsNonePalateSVG
};
